import axios from "axios";

const API_VERSION = "v1";

export interface CreateEmbedSessionRequest {
  client_id: string;
  embed_key: string;
  applicant_id?: string;
  product_selection?: string[];
  parent_origin: string;
}

export interface CreateEmbedSessionResponse {
  access_token: string;
  expires_in: number;
  session_id: string;
  token_type?: "Bearer";
}

export async function createEmbedSession(
  input: CreateEmbedSessionRequest
): Promise<CreateEmbedSessionResponse> {
  const response = await axios.post(
    `${process.env.REACT_APP_SERVER_URL}/${API_VERSION}/embed/sessions`,
    input,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
}

export async function refreshEmbedSession(
  sessionId: string,
  accessToken: string
): Promise<CreateEmbedSessionResponse> {
  const response = await axios.post(
    `${process.env.REACT_APP_SERVER_URL}/${API_VERSION}/embed/sessions/refresh`,
    { session_id: sessionId },
    {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    }
  );

  return response.data;
}
